import Logger from '../Log'
import StartEventHook from './StartEventHook'
import FillManager from '../FillManager'
import JsTagFillMethod from '../fillers/JsTagFillMethod'
import { bidderForCode } from '../utils'

const Log = Logger.for('JsTagHook')

export default class JsTagHook extends StartEventHook {
  constructor () {
    super('JsTagHook')
  }

  async run (remoteConfig) {
    let tags = bidderForCode('JSTAG', remoteConfig.bidders(), true)
    if (!tags) return

    if (!(tags instanceof Array)) {
      tags = [tags]
    }

    for (const tag of tags) {
      if (!tag.params.bidder || !tag.params.tag) {
        Log.warn('Had js tag entry but missing bidder or tag content')
        continue
      }

      Log.debug('Registering js tag for ' + tag.params.bidder)
      FillManager.register(new JsTagFillMethod(tag))
    }
  }
}
